// Testimonials.js
import React from 'react';
import { FaStar } from 'react-icons/fa'
import styles from './testimonial.module.css';

const testimonialsData = [
  {
    id: 1,
    name: "Tina",
    description: "Saya beli payung dan kotak makan dari Jooalan, langsung habis dalam dua minggu. Marginnya bisa 50%! Selalu repeat.",
    imageUrl: "/img/common/testi1.png",
  },
  {
    id: 2,
    name: "Marcell",
    description: "Timnya selalu fast respond! Harganya terbaik. Selalu mudah beli barang di Jooalan. Puas banget.",
    imageUrl: "/img/common/testi2.png",
  },
  {
    id: 3,
    name: "Putri",
    description: "Barangnya update terus dan CS-nya cepat tanggap. Enak buat saya yang stok sedikit dulu tapi beragam barang.",
    imageUrl: "/img/common/testi3.png",
  },
];

const Testimonials = () => {
  return (
    <div className="flex flex-col items-center w-full">
      <h1 className="text-black font-bold text-xl sm:text-3xl text-center">
        Testimoni Pelanggan
      </h1>
      <div className="flex flex-row justify-center w-full">
        <div className="mt-8 flex flex-row gap-6 overflow-x-scroll w-full max-w-max px-8" style={{
          scrollbarWidth: 'none'
        }}>
          {testimonialsData.map((testimonial) => (
            <div key={testimonial.id} className="flex shrink-0 flex-col relative rounded-xl bg-[url(/img/jooalan/testi-bg.png)] bg-repeat px-8 pt-6 pb-12 w-[320px] shadow-light border border-gray-300">
              <div className="z-10 opacity-100">
                <div className="flex flex-row gap-4 z-10">
                  <img src={testimonial.imageUrl} alt={testimonial.name} className="size-16 rounded-full" />
                  <div className="flex flex-col font-bold text-md">
                    {testimonial.name}
                    <div className="flex flex-row gap-1 mt-1">
                      <FaStar size={16} className="text-yellow-600" />
                      <FaStar size={16} className="text-yellow-600" />
                      <FaStar size={16} className="text-yellow-600" />
                      <FaStar size={16} className="text-yellow-600" />
                      <FaStar size={16} className="text-yellow-600" />
                    </div>
                  </div>
                </div>
                <div className="border-t border-t-gray-600 my-4" />
                <p>{testimonial.description}</p>
              </div>
              <div className="absolute h-3/4 inset-x-0 top-0 z-1" style={{ background: 'linear-gradient(180deg,rgba(248, 250, 252, 1) 0%, rgba(248, 250, 252, 1) 20%, rgba(248, 250, 252, 0) 100%)' }} />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.indicator}>
        {/* Add your indicator logic here */}
      </div>
    </div>
  );
};

export default Testimonials;